import { Box, Chip, Divider, Grid, Link, Stack, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import logo from '../assets/appbar-logo-2x.png'

const LINK_COLUMNS = [
  {
    heading: 'Company',
    links: [
      { label: 'About', to: '/about' },
      { label: 'Support', to: '/support' },
      { label: 'Contact', href: 'mailto:admin@terra-planner.com' },
    ],
  },
  {
    heading: 'Legal',
    links: [
      { label: 'Legal', to: '/legal' },
    ],
  },
  {
    heading: 'More',
    links: [
      { label: 'Sitemap', to: '/sitemap' },
      { label: 'Attributions', to: '/attributions' },
    ],
  },
]

const FooterLink = ({ label, to, href }) => {
  if (href) {
    return (
      <Link href={href} underline="hover" color="text.secondary" variant="body2" sx={{ display: 'block', py: 0.25 }}>
        {label}
      </Link>
    )
  }
  return (
    <Link component={RouterLink} to={to} underline="hover" color="text.secondary" variant="body2" sx={{ display: 'block', py: 0.25 }}>
      {label}
    </Link>
  )
}

export const MarketingFooter = () => {
  return (
    <Box
      component="footer"
      sx={{
        borderTop: '1px solid',
        borderColor: 'divider',
        bgcolor: 'action.hover',
        py: { xs: 4, md: 5 },
        px: { xs: 3, md: 6 },
      }}
    >
      <Box sx={{ maxWidth: 1100, mx: 'auto' }}>
        <Grid container spacing={4} alignItems="flex-start">
          <Grid size={{ xs: 12, sm: 'auto' }}>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.5 }}>
              <Box
                component="img"
                src={logo}
                alt="TerraPlanner"
                sx={{ height: 80, width: 'auto', display: 'block' }}
              />
              <Typography
                component="sup"
                variant="caption"
                color="text.secondary"
                sx={{ fontSize: '0.55rem', lineHeight: 1, verticalAlign: 'super', mt: 0.5 }}
              >
                TM
              </Typography>
            </Box>
          </Grid>

          <Grid size={{ xs: 12, sm: 'grow' }}>
            <Grid container spacing={{ xs: 3, md: 4 }}>
              {LINK_COLUMNS.map((col) => (
                <Grid key={col.heading} size={{ xs: 4 }}>
                  <Typography variant="caption" fontWeight={600} color="text.primary" textTransform="uppercase" letterSpacing={1} display="block" mb={1}>
                    {col.heading}
                  </Typography>
                  <Stack spacing={0.25}>
                    {col.links.map((link) => (
                      <FooterLink key={link.label} {...link} />
                    ))}
                  </Stack>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3 }} />

        <Typography variant="body2" color="text.secondary" textAlign="center">
          {'\u00a9'} {new Date().getFullYear()} TerraPlanner. All Rights Reserved.
        </Typography>
      </Box>
    </Box>
  )
}
